import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Бухгалтер';
render(<React.StrictMode data-id="element-329">
    <App data-id="element-330" />
  </React.StrictMode>, document.getElementById('root'));